// extracted by mini-css-extract-plugin
export default {"systemNotes":"instanceLogs-module__systemNotes___u3MsC","systemNotes__header":"instanceLogs-module__systemNotes__header___uEsdO","logs":"instanceLogs-module__logs___E0zEZ"};